export default __webpack_public_path__ + "static/media/Diamond_Edge_large_13.0e7177cf.jpg";